import React, {useCallback, useEffect, useState} from 'react'
import {httpClient} from "../../../service";
import {ActionResult, HttpMethod} from "../../../model";
import {useAsync} from "react-async";
import LoadingHtml from "../../../shared/Loading";
import ErrorPage from "../../../shared/ErrorPage";
import {ComboAction} from "../../../model/ActionResult";
import {Link} from "react-router-dom";
import {useDispatch} from 'react-redux'
import {boardActions} from '../../../store/board'
import {useSelector} from '../../../store';
import {titleActions} from '../../../store/boardTitle';

const CategoryHtml = (props: any) => {
    const forumCode = props.forumCode;
    const url = `boards/categories/${forumCode}`;
    const dispatch = useDispatch();
    const {s} = useSelector(state => state.board);
    const [isSearch, setSearch] = useState<Boolean>(false);
    const handleChange = useCallback((item: ComboAction<number>) => {
        console.log('search text init');
        dispatch(boardActions.init());
    }, []);


    const options = {promiseFn: httpClient, method: HttpMethod.GET, url};
    const {data: act, error, isLoading} = useAsync<ActionResult>(options);

    useEffect(() => {
            setSearch(s === true);
    }, [s]);
    const [items,setItems]=useState<ComboAction<number>[]>([]);
    const [categoryId,setCategoryId]=useState<number>(0);
    useEffect(()=>{
        console.log(`categoryHtml categoryId=${props.categoryId}`);
        const categoryId = props.categoryId ?? items[0].value;
        setCategoryId(categoryId);
        if(act && act.result){
            const items: ComboAction<number>[] = act.data;
            setItems(items);
            const itemModel=categoryId===0 ? items[0]:items.filter(a=>a.value.toString() === categoryId)[0];
            if(itemModel){
                dispatch(titleActions.setModel({name: itemModel.text}));
            }
        }
    },[props.categoryId,act]);

    if (isLoading) return <LoadingHtml/>;
    if (error) return <ErrorPage/>;
    if (!act) return null;
    if (!act.result) return <ErrorPage/>;


    return <div className="bloc l-bloc" id="bloc-0">
        <div className="container category-tabs">
            <div className={'task-tabs'}>
                {
                    items.map((item, index) => {
                        let catCls = '';
                        if (isSearch !== true) {
                            if (categoryId === 0 && index === 0) {
                                catCls = 'active';
                            } else {
                                catCls = item.value.toString() === categoryId.toString() ? 'active' : '';
                            }
                        }
                        const url = `/boards/${forumCode}/${item.value}?ct=${item.text}`;
                        return (
                            <Link to={url} key={item.value} onClick={(e) => handleChange(item)}
                                  className={catCls}>{item.text}</Link>
                        )
                    })
                }
            </div>
        </div>
    </div>


}

export default CategoryHtml;
